import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * Represents entity of the migration in the database.
 */
export var Migration = /*#__PURE__*/_createClass(
// -------------------------------------------------------------------------
// Constructor
// -------------------------------------------------------------------------
function Migration(id, timestamp, name, instance, transaction) {
  _classCallCheck(this, Migration);
  this.id = id;
  this.timestamp = timestamp;
  this.name = name;
  this.instance = instance;
  this.transaction = transaction;
});